import "regenerator-runtime/runtime";

/**** To drive the Grid Card Functionality ****/
//Any changes done to this will also affect UCITS. Contact Eugene for any questions
$(_ => {

    //Guard - run only if there is an insights grid component on the page
    if( $(".ve-dynamic-related-media").length == 0 ) return;

    /*** veRelatedMedia = the roubust insights grid component designed to interface with the related media service */
    window.veRelatedMedia = {
        initialised: false,
        relatedMediaItems: [],
        endpoint: "/Main/RelatedMediaUsBlock/GetMediaWithPaging",
        debug: false,
        shouldScrollIntoView: false,


        /**
         * Accepts the grid object and based on the data available, query the endpoint and obtain the media items.
         * @param {any} relatedMediaItem
         */
        getData: async relatedMediaItem => {
            veRelatedMedia.debug ? console.time("Retrive Data for Related Media-" + relatedMediaItem.id) : false;
            try {
                const data = await $.post(veRelatedMedia.endpoint,
                    {
                        pageNumber: relatedMediaItem.nextPage,
                        pageSize: relatedMediaItem.count,
                        QueryFormat: relatedMediaItem.insightsType,
                        Author: relatedMediaItem.authorID,
                        Category: relatedMediaItem.categoryID,
                        TopicalTags: relatedMediaItem.topicalTags,
                        ContentTypeTags: relatedMediaItem.contentTypeTags,
                        LocationTags: relatedMediaItem.locationTags,
                        FundTags: relatedMediaItem.fundTags,
                        SiteContext: veRelatedMedia.getSiteContext(relatedMediaItem.siteContext),
                        Lang: relatedMediaItem.lang,
                    }
                );

                veRelatedMedia.debug ? console.timeEnd("Retrive Data for Related Media-" + relatedMediaItem.id) : false;

                veRelatedMedia.debug ? console.log(data) : false;

                veRelatedMedia.debug ? console.time("Render Items for Related Media-" + relatedMediaItem.id) : false;

                veRelatedMedia.drawRelatedMedia(relatedMediaItem, data);

                veRelatedMedia.updateDropdownStatus(data.Result, relatedMediaItem);
            }
            catch (e) {
                veRelatedMedia.debug ? console.timeEnd("Retrive Data for Related Media-" + relatedMediaItem.id) : false;
                console.log("Error occured while fetching Related Media Grid Data.");
                console.error(e);
            }

        },

        clearData: (relatedMediaItem) => {
            $(relatedMediaItem.element).find(".draw-area").empty();
            $(relatedMediaItem.element).find(".view-more").removeClass("hide").empty().show();
        },


        /**
         * Draws the related media item based on data obtained from the endpoint response.
         * Needs the data as well as the appropriate grid to be drawn.
         * @param {any} relatedMediaItem
         * @param {any} data
         */
        drawRelatedMedia: (relatedMediaItem, data) => {
            if(!data) return console.error("There is no data to render!");
            if(!relatedMediaItem) return console.error("There is no relatedMediaItem to render!");

            //now that we got the data, lets see if there is more pages and then increment the next page.
            if (data.Result.HasMoreItems) {
                veRelatedMedia.relatedMediaItems[relatedMediaItem.id].nextPage++;
                $(relatedMediaItem.element).find(".view-more").show();
            } else {
                $(relatedMediaItem.element).find(".view-more").hide();
            }

            var mkGrid = ""; //The markup for the entire grid component to be drawn, made of multiple insights items.
            var unformattedMessage = "";
            var formattedMessage = "";

            if (data.Result.GridCardDetails.length > 0) {
                data.Result.GridCardDetails.forEach((e, i) => {
                    mkGrid += veRelatedMedia.renderItem(e, relatedMediaItem.template ?? "insights-grid")
                })
            }
            else {
                const currentCategory = $("#InsightsDropdown .dropdown__label").text().trim();
                const currentMediaType = $("#InsightsTypeDropdown .dropdown__label").text().trim();
                var message = "";
                if (currentCategory && currentCategory != veDictionary.allInsights && currentMediaType && currentMediaType != veDictionary.allFormats) {
                    unformattedMessage = veDictionary.noCategoriesVisit;
                    formattedMessage = unformattedMessage.replace('{0}', currentCategory).replace('{1}', currentMediaType.toLowerCase()).replace('{2}', currentMediaType.toLowerCase());
                    //message += `Sorry, there are no ${currentCategory} ${currentMediaType.toLowerCase()} at this time. Come back and visit for future ${currentMediaType.toLowerCase()}.`;
                    message += formattedMessage;
                }
                else if (currentCategory && currentCategory != veDictionary.allInsights) {
                    unformattedMessage = veDictionary.noCategoriesAtThisTime;
                    formattedMessage.replace('{0}', currentCategoy);
                    //message += `Sorry, there are no ${currentCategoy} insights at this time.`;
                    message += formattedMessage;
                }
                else {
                    message += veDictionary.noCategories;
                }
                mkGrid += `<div class="text-center w-100"><p>${message}</p></div>`;
            }
            //iterate and render the elems


            //Draw the grid on the component and enable the view more button.
            $(relatedMediaItem.element).find(".draw-area").append(mkGrid);
            $(relatedMediaItem.element).find(".view-more .btn-primary").attr("disabled", false);

            veRelatedMedia.debug ? console.timeEnd("Render Items for Related Media-" + relatedMediaItem.id) : false;
        },

    
        /**
         * Generates the markup for a signle related media media item, based on a template
         * @param {any} item
         * @param {any} template
         */
        renderItem: (item, template) => {
            var mkimage = item.PostSmallImage ?
                `<div class="position-relative"><a data-ve-gtm="item-image" class="grid-card__image-link" href="${item.MediaLink}">
                                    <div class="grid-card__image-container mb-3 no-print">
                                      <div class="image grid-card__image" style="background-image:url(${item.PostSmallImage});padding-bottom:56.25%">
                                        <img alt="${item.Title}" class="image__img" src="${item.PostSmallImage}"></div>
                                    </div>
                                    <div class="grid-card__image-icon">${veRelatedMedia.getSvg(item.Type)}</div>
                                  </a></div>`
                : "";

            var description = (item.Details != null && item.Details != "") ? item.Details : item.Description ?? "";
            var mksummary = item.PostSmallImage ? "" : `<div data-ve-gtm="item-abstract" class="grid-card__body">
                                 ${description}
                                </div>`;

            var rnAuthors = (authors) => {
                var mkAuthors = "";

                authors.forEach(e => {
                    const hasauthorLink = _ =>  e.Url != null && e.Url != "" && !veRelatedMedia.getCurrentAuthor();
                    var aOpen = hasauthorLink() ? `<a data-ve-gtm="${veRelatedMedia.getGtmAuthorAttributeValue(item.Type)}" class="grid-card__label-link" href="${e.Url}">` : `<div class="grid-card__label-link">`;
                    var aClose = hasauthorLink() ? `</a>` : "</div>";
                    //var aOpen = `<div data-ve-gtm="${veRelatedMedia.getGtmAuthorAttributeValue(item.Type)}" class="grid-card__label-link">`;
                    //var aClose = "</div>";
                    mkAuthors += `<div class="grid-card__author">${aOpen}<span class="grid-card__label-title text-util-md">${e.Name}</span><span class="grid-card__label-title text-util-md">${e.Title != null ? e.Title : ""}</span>${aClose}</div>`
                });
                return mkAuthors;
            }
            
            /*var publishedDate = convCSDate(item.PublishDate)*/ 

            var mkcategory = item.Category ? `<span data-ve-gtm="item-category" class="text-util-md">${item.Category} ${veRelatedMedia.getRelatedMediaType(item.Type)}</span>` : "";
            mkcategory = item.CategoryUrl != null && item.CategoryUrl != "" && !veRelatedMedia.getCurrentCategory() ? `<a data-ve-gtm="item-category" class="grid-card__eyebrow-link" href="${item.CategoryUrl}">${mkcategory}</a>` : mkcategory;

            var mkCategory = item.Category ? `<div class="grid-card__eyebrow">${mkcategory}</div>` : "";
            var badge = item.Badge ? `<span class="grid-card__badge badge mb-2">${item.Badge} CE Credit</span>` : "";
            var liveOn = item.IsUpcomingWebinar ? '<span class="grid-card__badge badge mb-2">Live On</span>' : "";

            var rnReadTime = (insightsType, readTime) => {
                if (readTime == null || typeof insightsType != "string") return "";
                switch (insightsType.toLowerCase()) {
                    case "blog":
                        return `<p class="text-util-md mb-2 grid-card__read-time">${item.FormattedTime}</p>`;
                    case "video":
                        return `<p class="text-util-md mb-2 grid-card__read-time">${item.FormattedTime}</p>`;
                    case "podcast":
                        return `<p class="text-util-md mb-2 grid-card__read-time">${item.FormattedTime}</p>`
                    default:
                        return "";
                }
            }        

            switch (template) {

                /***
                 *  In future if other templates are required for the grid, we can add them here as another case.
                 **/
                case "landing-grid":
                    return `<div class="insights-grid__item col-md-6 col-lg-3">
                              <div data-ve-gtm="${veRelatedMedia.getGtmGridCardAttributeValue(item.Type)}" class="grid-card">
                                ${mkimage}
                                ${mkCategory}
                                <div class="grid-card__header"><a data-ve-gtm="item-title" class="grid-card__title-link" href="${item.MediaLink}">
                                    <h3 class="mb-0">${item.Title}</h3>
                                  </a></div>
                                ${badge}
                                ${rnAuthors(item.Authors)}
                                <p data-ve-gtm="item-date" class="text-util-md mb-2">${liveOn} ${item.FormattedPublishDate}</p>
                                ${rnReadTime(veRelatedMedia.getRelatedMediaType(item.Type),item.Time)}
                                ${mksummary}
                                <div class="grid-card__divider"></div>
                              </div>
                    </div>`;
                case "insights-grid":
                default:
                    return `<div class="insights-grid__item col-md-6 col-lg-4">
                              <div data-ve-gtm="${veRelatedMedia.getGtmGridCardAttributeValue(item.Type)}" class="grid-card">
                                ${mkimage}
                                ${mkCategory}
                                <div class="grid-card__header"><a data-ve-gtm="item-title" class="grid-card__title-link" href="${item.MediaLink}">
                                    <h3 class="mb-0">${item.Title}</h3>
                                  </a></div>
                                ${badge}
                                ${rnAuthors(item.Authors)}
                                <p data-ve-gtm="item-date" class="text-util-md mb-2">${liveOn} ${item.FormattedPublishDate}</p>
                                ${rnReadTime(veRelatedMedia.getRelatedMediaType(item.Type),item.Time)}
                                ${mksummary}
                                <div class="grid-card__divider"></div>
                              </div>
                    </div>`;
            }
        },

         /***
         * Function to read the query strings and then tune the config of the veRelatedMedia item.
         * */
        configureGridByQueryStrings: () => {
            //debugger;
            //Try to get the mediaType from the URL
            const mediaType = getQueryStringParam("mediaType");
            const category = getQueryStringParam("category");
            if (category) {

                const getCategoryFromString = catString => {
                    const selectedCat = $("#InsightsDropdown .dropdown__item").toArray().find(x => {
                        const matchesCategoryName = $(x).text().toLowerCase().replace(/[ ]/g, "-") === catString;
                        const matchesNameInURL = $(x).data("categoryurlname")?.toLowerCase().replace(/[ ]/g, "-") === catString;
                        return matchesCategoryName || matchesNameInURL;
                    });
                    if (selectedCat) {
                        //return Array [categoryName, categoryID];
                        return [$(selectedCat).text(), $(selectedCat).attr("value")];
                    }
                    return [false, false];
                }

                const setCategory = insightsCategory => {
                    //get the Id and name of the category
                    if (typeof insightsCategory != "string") return false;
                    const catString = insightsCategory.toLowerCase();
                    if (!catString) return false;
                    const [catName, catId] = getCategoryFromString(catString);

                    if(!catId || !catName) return;
                    $(".ve-dynamic-related-media:first").data("categoryid", catId).attr("data-categoryid", catId);
                    $("#InsightsDropdown .dropdown__label").text(catName);
                }

                setCategory(category);
            }

            if (mediaType) {
                //To set the mediatype to the first item.
                const setType = insightsType => {
                    $(".ve-dynamic-related-media:first").data("insightstype", insightsType).attr("data-insightstype", insightsType);
                    $("#InsightsTypeDropdown .dropdown__label").text(insightsType + "s");
                    insightsType == "All" ? $("#InsightsTypeDropdown .dropdown__label").text("All Formats") : false;
                }

                veRelatedMedia.shouldScrollIntoView = true;

                //we switch so only the relavent ones can be used, all others will be ignored.
                //Also capitalisation of first letter.
                switch (mediaType.toLowerCase()) {
                    case "webinar":
                        setType("Webinar")
                        break;                    
                    case "blog":
                        setType("Blog")
                        break;                    
                    case "video":
                        setType("Video")
                        break;                    
                    case "podcast":
                        setType("Podcast")
                        break;                         
                    case "all":
                        setType("All")
                        break;                    
                    default:
                        return false;
                }
            }

            return false;
        },

        scrollIntoView: _ => {
            if (veRelatedMedia.shouldScrollIntoView) {
                //scroll into view
                const rmOffset = $(".ve-dynamic-related-media:first")[0].offsetTop;

                //get category to see if there is a selected category, aka. not a capability page.
                const currentCategory = $(".ve-dynamic-related-media:first").data("category");
                if (rmOffset) { // && !currentCategory) {
                    window.scrollTo(0, rmOffset - 15);
                }
            }
        },

        updateDropdownStatus: async (data, relatedMediaItem) => {
            const updateCategories = function () {
                const NoCategorySelected = $("#InsightsDropdown .dropdown__label").text().trim() == $("#InsightsDropdown .dropdown__item:first").text().trim();
                $("#InsightsDropdown .dropdown-item").each((i, e) => {
                    const catValue = $(e).attr("value");
                    if (catValue) {
                        const catCount = data.FacetTerms.Categories[catValue];
                        //Do not disable categories if both a media type and category is displayed.
                        if ((!catCount || catCount === 0) && !relatedMediaItem.hasBothCategoryAndMediaType && NoCategorySelected) return $(e).attr("disabled", true);
                    }
                    return $(e).removeAttr("disabled");
                })
            }

            const updateMediaTypes = function () {
                const AllTypes = $("#InsightsTypeDropdown .dropdown-item:first").attr('value');
                const NoCategorySelected = $("#InsightsDropdown .dropdown__label").text().trim() == $("#InsightsDropdown .dropdown__item:first").text().trim();
                $("#InsightsTypeDropdown .dropdown-item").each((i, e) => {
                    const catValue = $(e).attr("value");
                    if (catValue === AllTypes) return;
                    if (catValue) {
                        const catCount = data.FacetTerms.RelatedMediaTypes[catValue];
                        if ((!catCount || catCount === 0) && !relatedMediaItem.hasBothCategoryAndMediaType && !NoCategorySelected) return $(e).attr("disabled", true);
                    }
                    //disable them ONLY if the category was selected, not if both are selected...
                    return !relatedMediaItem.hasBothCategoryAndMediaType ? $(e).removeAttr("disabled") : false;
                })
            }

            const hideDropdowns = function () {
                if(!data.MediaTypes) return;

                //see if any of them need to be hidden
                    //get list of all media types    
                    const MediaTypeKeys = Object.keys(data.MediaTypes);
                    //filter those that are false (not available)
                    const UnavailableMediaTypes = MediaTypeKeys.filter(x => !data.MediaTypes[x]);
                    //if there are nothing to hide ignore.
                    if (UnavailableMediaTypes.length == 0) return;

                //get the list of corresponsing values
                const MediaTypesToHide = UnavailableMediaTypes.map(x => !isNaN(x) ? veRelatedMedia.getRelatedMediaType(Number(x)).toLowerCase() : "error")
                
                veRelatedMedia.debug ? console.log("To hide") : false;
                veRelatedMedia.debug ? console.log(MediaTypesToHide) : false;

                //iterate through dropdowns and hide if relavent.
                $("#InsightsTypeDropdown .dropdown-item").each((i, e) => {
                    const medValue = $(e).attr("value")?.toLowerCase();
                    if (medValue && MediaTypesToHide.includes(medValue)) return $(e).hide();
                })
            }

            updateCategories();
            updateMediaTypes();
            hideDropdowns();
        },
        getCurrentCategory: x => {
            const currentCat = veRelatedMedia.relatedMediaItems[0].category
            if(!currentCat) return false;
            if(currentCat === "All") return false;
            return currentCat;
        },
        getCurrentAuthor: x => veRelatedMedia.relatedMediaItems[0].author || false,


        /**
         * Returns common SVGs used in the grid.
         * Case 1- blog, Case 2 - video, Case 3 - Webinar, Case 4 - Podcast
         * @param {any} name
         */
        getSvg: name => {
            switch (name) {
                case 1:
                    return `<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="blog" class="svg-inline--fa fa-blog fa-w-16 fa-3x icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
                                <path fill="currentColor" d="m 17.112303,7.9225352 -3.721739,4.1483138 -0.118625,1.133376 1.045882,-0.170256 3.70764,-4.1325758 z M 18.863762,7.4547443 18.376858,6.9901735 c -0.0817,-0.078021 -0.185238,-0.1261868 -0.271378,-0.1238269 -0.03333,-0.00163 -0.06589,0.010082 -0.09014,0.032414 l -0.599307,0.6181672 0.941184,0.9337764 0.612789,-0.6322986 c 0.06242,-0.064287 0.03017,-0.2334938 -0.106246,-0.3636613 z M 6.8352423,7.2114327 a 0.52816901,0.52816901 0 0 0 -0.5281691,0.528169 0.52816901,0.52816901 0 0 0 0.5281691,0.528169 h 7.7781137 a 0.52816901,0.52816901 0 0 0 0.528169,-0.528169 0.52816901,0.52816901 0 0 0 -0.528169,-0.528169 z m 0,3.5211263 a 0.52816901,0.52816901 0 0 0 -0.5281691,0.528169 0.52816901,0.52816901 0 0 0 0.5281691,0.528169 h 4.9612127 a 0.52816901,0.52816901 0 0 0 0.528169,-0.528169 0.52816901,0.52816901 0 0 0 -0.528169,-0.528169 z m 0,3.521127 a 0.52816901,0.52816901 0 0 0 -0.5281691,0.528169 0.52816901,0.52816901 0 0 0 0.5281691,0.528169 H 18.471466 a 0.52816901,0.52816901 0 0 0 0.528169,-0.528169 0.52816901,0.52816901 0 0 0 -0.528169,-0.528169 z m 0,3.521127 a 0.52816901,0.52816901 0 0 0 -0.5281691,0.528169 0.52816901,0.52816901 0 0 0 0.5281691,0.528169 H 18.471466 a 0.52816901,0.52816901 0 0 0 0.528169,-0.528169 0.52816901,0.52816901 0 0 0 -0.528169,-0.528169 z M 12.5,0 C 5.602697,0 0,5.602697 0,12.5 0,19.397303 5.602697,25 12.5,25 19.397303,25 25,19.397303 25,12.5 25,5.602697 19.397303,0 12.5,0 Z m 0,1.056338 c 6.326416,0 11.443662,5.117246 11.443662,11.443662 0,6.326416 -5.117246,11.443662 -11.443662,11.443662 C 6.173584,23.943662 1.056338,18.826416 1.056338,12.5 1.056338,6.173584 6.173584,1.056338 12.5,1.056338 Z">
                                </path>
                              </svg>`;
                case 2:
                    return `<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="play-circle" class="svg-inline--fa fa-play-circle fa-w-16 fa-3x icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M 10.1525,7.6262504 C 9.4088471,7.6408774 8.7143741,8.2420884 8.715,9.0612499 V 14.9375 c -8.432e-4,1.092215 1.2338231,1.796302 2.17375,1.24 l 4.96875,-2.93875 c 0.923476,-0.546327 0.923476,-1.932423 0,-2.47875 L 10.88875,7.8212497 C 10.653768,7.6821749 10.400384,7.6213758 10.1525,7.6262504 Z M 9.9100002,8.6299998 C 10.048592,8.5509094 10.229738,8.5467295 10.4,8.6475003 l 4.96875,2.9387497 c 0.333052,0.197033 0.333052,0.629217 0,0.82625 L 10.4,15.351252 C 10.059477,15.552794 9.6746977,15.3332 9.675,14.937503 V 9.0612525 C 9.6748489,8.863405 9.7714074,8.7090934 9.9100002,8.6300024 Z M 12,0 C 5.37776,0 0,5.37776 0,12 0,18.62224 5.37776,24 12,24 18.62224,24 24,18.62224 24,12 24,5.37776 18.62224,0 12,0 Z m 0,0.96 C 18.10352,0.96 23.04,5.89648 23.04,12 23.04,18.10352 18.10352,23.04 12,23.04 5.89648,23.04 0.96,18.10352 0.96,12 0.96,5.89648 5.89648,0.96 12,0.96 Z">
                                </path>
                              </svg>`
                case 3:
                    return `<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="webinar-circle" class="svg-inline--fa fa-webinar-circle fa-w-16 fa-3x icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.5 23.5">
                                <path fill="currentColor" d="M 12.000217,8.935 C 10.864438,8.935 9.935,9.8644377 9.935,11.000218 c 3e-7,1.13578 0.929438,2.065218 2.065217,2.065218 1.135779,0 2.065217,-0.929438 2.065217,-2.065218 0,-1.1357803 -0.929438,-2.0652181 -2.065217,-2.065218 z m -0.0213,1.065218 c 0.246244,0 0.49031,0.10086 0.695313,0.289063 0.400499,0.408895 0.394334,0.98771 0.01172,1.347656 -0.414629,0.389463 -1.029443,0.405216 -1.382814,0.03125 -0.388785,-0.414049 -0.407064,-1.02383 -0.0332,-1.375 0.206975,-0.194413 0.458712,-0.292969 0.708984,-0.292969 z M 10.900391 13.972656 C 9.3932093 13.972656 8.2597656 15.372808 8.2597656 17 L 9.7402344 17 C 9.7402344 16.029192 10.333572 15.455078 10.900391 15.455078 L 13.099609 15.455078 C 13.703906 15.455078 14.259766 16.079104 14.259766 17 L 15.740234 17 C 15.740234 15.428896 14.655313 13.972656 13.099609 13.972656 L 10.900391 13.972656 z M 6.1992188 6.5 C 5.4755755 6.5 4.9277344 7.1349285 4.9277344 7.8496094 L 4.9277344 16.150391 C 4.9277344 16.865071 5.4755755 17.5 6.1992188 17.5 L 17.654297 17.5 C 17.654945 17.5 17.655602 17.500001 17.65625 17.5 C 18.378933 17.498864 18.927734 16.86514 18.927734 16.150391 L 18.927734 7.8496094 C 18.927734 7.1342193 18.37794 6.5 17.654297 6.5 L 6.1992188 6.5 z M 6.1992188 7.5 L 17.654297 7.5 C 17.784654 7.5 17.927734 7.6249994 17.927734 7.8496094 L 17.927734 16.150391 C 17.927734 16.375001 17.784654 16.5 17.654297 16.5 L 6.1992188 16.5 C 6.068862 16.5 5.9277344 16.37571 5.9277344 16.150391 L 5.9277344 7.8496094 C 5.9277344 7.6242902 6.068862 7.5 6.1992188 7.5 z M 8 18.5 L 8 19.5 L 16 19.5 L 16 18.5 L 8 18.5 z  M 12,0.25 C 5.5195377,0.25 0.25,5.5195377 0.25,12 0.25,18.480462 5.5195377,23.75 12,23.75 18.480462,23.75 23.75,18.480462 23.75,12 23.75,5.5195377 18.480462,0.25 12,0.25 Z M 12,1.25 C 17.946378,1.25 22.75,6.0536221 22.75,12 22.75,17.946378 17.946378,22.75 12,22.75 6.0536221,22.75 1.25,17.946378 1.25,12 1.25,6.0536221 6.0536221,1.25 12,1.25 Z">
                                </path>
                              </svg>`;
                case 4:
                    return `<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="microphone-circle" class="svg-inline--fa fa-microphone-circle fa-w-16 fa-3x icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <path fill="currentColor" d="m 6.595052,9.807292 a 0.5,0.5 0 0 0 -0.5,0.5 v 1.800781 c 0,3.078211 2.394846,5.53622 5.404948,5.803386 v 1.804687 H 8.2343747 a 0.5,0.5 0 0 0 -0.5,0.5 0.5,0.5 0 0 0 0.5,0.5 H 11.990885 12 15.765625 a 0.5,0.5 0 0 0 0.5,-0.5 0.5,0.5 0 0 0 -0.5,-0.5 H 12.5 v -1.804687 c 3.010102,-0.267166 5.404948,-2.725175 5.404948,-5.803386 v -1.800781 a 0.5,0.5 0 0 0 -0.5,-0.5 0.5,0.5 0 0 0 -0.5,0.5 v 1.800781 c 0,2.715063 -2.189885,4.904948 -4.904948,4.904948 -2.7150633,0 -4.904948,-2.189885 -4.904948,-4.904948 v -1.800781 a 0.5,0.5 0 0 0 -0.5,-0.5 z M 12,0 C 5.3785053,0 0,5.3785053 0,12 0,18.621495 5.3785053,24 12,24 18.621495,24 24,18.621495 24,12 24,5.3785053 18.621495,0 12,0 Z m 0,1 C 18.081055,1 23,5.9189453 23,12 23,18.081055 18.081055,23 12,23 5.9189453,23 1,18.081055 1,12 1,5.9189453 5.9189453,1 12,1 Z m 0.0063,13.331333 v 0 c -1.270255,0 -2.300001,-1.104364 -2.300001,-2.466666 V 6.9313327 c 0,-1.3623014 1.029746,-2.466666 2.300001,-2.466666 v 0 c 1.270253,0 2.299999,1.1043646 2.299999,2.466666 v 4.9333343 c 0,1.362302 -1.029746,2.466666 -2.299999,2.466666 z">
                                  </path>
                                </svg>`;
                default:
                    return "";
            }
        },

        /**
         * Returns the appropriate media type based on enum
         * Case 1- blog, Case 2 - video, Case 3 - Webinar, Case 4 - Podcast
         * @param {any} name
         */
        getRelatedMediaType: name => {
            switch (name) {
                case 1:
                    return "Blog";
                case 2:
                    return "video";
                case 3:
                    return "Webinar";
                case 4:
                    return "Podcast";
                default:
                    return "";
            }
        },


        getSiteContext: name => {
            switch (name) {
                case "Unknown":
                    return 0;
                case "Us":
                    return 1;
                case "Ucits":
                    return 2;
                case "Corp":
                    return 3;
                case "ForeignTax":
                    return 4;
                case "Au":
                    return 5;
                case "Etn":
                    return 6;
                default:
                    return 1;
            }
        },

        /**
         * Returns Gtm grid card attribute
         * Case 1- blog, Case 2 - video, Case 3 - Webinar, Case 4 - Podcast
         * @param {any} name
         */
        getGtmGridCardAttributeValue: name => {
            switch (name) {
                case 1:
                    return "container-blog-post-item";
                case 2:
                    return "container-video-item";
                case 3:
                    return "container-webinar-item";
                case 4:
                    return "container-podcast-item";
                default:
                    return "";
            }
        },

        /**
         * Returns Gtm grid card attribute
         * Case 1- blog, Case 2 - video, Case 3 - Webinar, Case 4 - Podcast
         * @param {any} name
         */
        getGtmAuthorAttributeValue: name => {
            switch (name) {
            case 3:
                return "item-presenter";
            default:
                return "item-author";
            }
        },

        /**
         * Init Function that reads all related media components and adds them to an object.
         * Then initialises the items and renders them.
         * */
        init: async (ignoreQueryStrings = false) => {

            if (!ignoreQueryStrings) {
                //readQueryStringParams to see if there is an override.
                veRelatedMedia.configureGridByQueryStrings();
            }

            $(".ve-dynamic-related-media").each((i, e) => {

                //check if it is to be loaded on first load only
                if ($(e).hasClass("first-load-only")) 
                {
                    //see if it's the first load and do not initialise.
                    if (getUserPageCount() > 1) {
                        $(e).parent().addClass("d-none");
                        return;
                    }
                };

                //check if it is to be loaded on first load only
                if ($(e).hasClass("not-first-load")) 
                {
                    //see if it's the first load and do not initialise.
                    if (getUserPageCount() < 2) {
                        $(e).parent().addClass("d-none");
                        return;
                    }
                };

                //debugger
                var relatedMediaItem = {
                    id: i,
                    element: e,
                    category: $(e).data("category") ?? "", 
                    categoryID: $(e).data("categoryid") ?? "",
                    topicalTags: $(e).data("topicaltags") ?? "", 
                    contentTypeTags: $(e).data("contenttypetags") ?? "", 
                    locationTags: $(e).data("locationtags") ?? "", 
                    fundTags: $(e).data("fundtags") ?? "", 
                    count: $(e).data("count") ?? 6, 
                    insightsType: $(e).data("insightstype") ?? "All",
                    author: $(e).data("author") ?? "",
                    authorID: $(e).data("authorid") ?? "",
                    template: $(e).data("template") ?? "insights-grid",
                    siteContext: $(e).data("sitecontext") ?? "",
                    lang: $(e).data("lang") ?? "",
                    hasBothCategoryAndMediaType: Boolean($(e).data("insightstype")) && Boolean($(e).data("categoryid")) && Boolean($(e).data("insightstype") != "All"),
                    nextPage: 0
                }
                //debugger
                veRelatedMedia.relatedMediaItems.push(relatedMediaItem);

            });

            veRelatedMedia.relatedMediaItems.forEach(async e => {
                
                $(e.element).find(".view-more").hide().append(`<button data-ve-gtm="read-more" class="insights-grid__button btn btn-primary no-print">${veDictionary.viewMore}</button>`);

                //get the data
                await veRelatedMedia.getData(e);

                //bind the button
                $(e.element).find(".view-more .btn-primary").click(async function () {
                    $(this).attr("disabled", true);
                    await veRelatedMedia.getData(e)
                });
            })
            //wait for half a ms before scrolling into view
            window.setTimeout(x => veRelatedMedia.scrollIntoView(), 200);
            veRelatedMedia.initialised = true;
        }
    /* End of veRelatedMedia */
    }

    veRelatedMedia.init();

    $(".insights-grid.ve-dynamic-related-media #InsightsDropdown .dropdown-item.dropdown__item").click(function () {
        var clickedCategoryID = $(this).val();
        var clickedCategoryName = $(this).text();
        $(".ve-dynamic-related-media:first").attr("data-categoryid", clickedCategoryID);
        $(".ve-dynamic-related-media:first").data("categoryid", clickedCategoryID);
        if (veRelatedMedia.relatedMediaItems[0].hasBothCategoryAndMediaType) {
            //both category and mediatype are selected, but if a new category is switched, we flip back to all media.
            $(".ve-dynamic-related-media:first").attr("data-insightstype", "All");
            $(".ve-dynamic-related-media:first").data("insightstype", "All");
            $("#InsightsTypeDropdown .dropdown__label").text(veDictionary.allFormats);
        }
        $("#InsightsDropdown .dropdown__label").text(clickedCategoryName);
        veRelatedMedia.relatedMediaItems.forEach(e => {
            veRelatedMedia.clearData(e);
        });
        veRelatedMedia.relatedMediaItems = [];
        
        veRelatedMedia.init(true);
    });

    $(".insights-grid.ve-dynamic-related-media #InsightsTypeDropdown .dropdown-item.dropdown__item").click(function () {
        var clickedInsightType = $(this).val();
        var clickedInsightName = $(this).text();
        $(".ve-dynamic-related-media:first").attr("data-insightstype", clickedInsightType);
        $(".ve-dynamic-related-media:first").data("insightstype", clickedInsightType);
        $("#InsightsTypeDropdown .dropdown__label").text(clickedInsightName);
        veRelatedMedia.relatedMediaItems.forEach(e => {
            veRelatedMedia.clearData(e);
        });
        veRelatedMedia.relatedMediaItems = [];
        veRelatedMedia.init(true);
    });

})

function convCSDate(dateString) {
    if (typeof dateString != "string") return console.error("Date needs to be string!")
    var date = new Date();
    try {
        date = new Date(dateString.substring(0, 19)); //Cutting off the timezone offset by taking only the first 19 characters
    }
    catch (e) {
        date = new Date(parseInt(dateString.replace(/[^0-9 +]/g, '')));
    }

    var year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    var month = new Intl.DateTimeFormat('en', { month: 'long' }).format(date);
    var day = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(date);

    return `${month} ${day}, ${year}`;
}

/**
 * Returns the value of a query string if available or false.
 * @param {any} queryString
 */
function getQueryStringParam(queryString) {
    const queryStrings = window.location.search.replace("?","").split("&").map(x => x.split("="));
    const results = queryStrings.find(x => x[0]?.toLowerCase() === queryString?.toLowerCase());
    if(results) return results[1];
    return false;
}


function getUserPageCount() {
    let microsite = (document.querySelector("#hdnCurrentMicrositeId"))?.value;
    // AU workaround
    if (!microsite) {
        microsite = (document.querySelector("#hdnSelectedCountry"))?.value.toLowerCase();
    }
    let key = "";
    switch (microsite) {
        case "global":
            key = "ve-PageVisitCount-corp";
            break;
        case "ucits":
            key = "ve-PageVisitCount-eu";
            break;
        case "au":
            key = "ve-PageVisitCount-au";
            break;
        default:
            key = "ve-PageVisitCount";
            break;
    }

    const visits = localStorage.getItem(key);
    return isNaN(visits) ? 0 : parseInt(visits);
}